// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
.sr-panel {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #ededed;
}
.sr-choice-row {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.sr-choice-tile {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 2px solid #ededed;
  background: #fff;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.sr-choice-tile:hover:not(:disabled) {
  border-color: #a3a3a3;
  background: #fafafa;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.sr-choice-tile:focus {
  outline: 2px solid rgba(0, 95, 240, 0.3);
  outline-offset: 1px;
}
.sr-choice-tile:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.sr-tile-include.sr-tile-selected {
  border-color: #16a34a;
  background: #f0fdf4;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
}
.sr-tile-exclude.sr-tile-selected {
  border-color: #dc2626;
  background: #fef2f2;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}
.sr-tile-icon {
  font-size: 1.15rem;
  line-height: 1;
}
.sr-tile-text {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
}
.sr-form {
  padding: 14px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #ededed;
}
.sr-form-exclude {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.12);
}
.sr-form-row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: start;
}
.sr-field-grow {
  min-width: 0;
}
.sr-field-grow .sr-textarea {
  max-width: 100%;
  width: 100%;
}
.sr-field {
  margin-bottom: 12px;
}
.sr-field:last-of-type {
  margin-bottom: 14px;
}
.sr-label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
}
.sr-opt {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}
.sr-amount-input {
  display: flex;
  align-items: center;
  max-width: 11rem;
  border: 1px solid #ededed;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.sr-amount-input:focus-within {
  border-color: #005ff0;
  box-shadow: 0 0 0 2px rgba(0, 95, 240, 0.1);
}
.sr-dollar {
  padding: 6px 8px 6px 10px;
  font-weight: 700;
  font-size: 0.88rem;
  color: #a3a3a3;
  background: #f5f5f5;
  border-right: 1px solid #ededed;
}
.sr-input {
  border: none;
  border-radius: 0;
  box-shadow: none;
  font-size: 0.95rem;
  font-weight: 700;
  color: #171717;
  padding: 6px 8px;
}
.sr-input:focus {
  box-shadow: none;
}
.sr-textarea {
  max-width: 22rem;
  border-radius: 6px;
  border-color: #ededed;
  font-size: 0.85rem;
}
.sr-textarea:focus {
  border-color: #005ff0;
  box-shadow: 0 0 0 2px rgba(0, 95, 240, 0.1);
}
.sr-select {
  max-width: 22rem;
  border-radius: 6px;
  border-color: rgba(220, 38, 38, 0.18);
  font-size: 0.85rem;
}
.sr-select:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
}
.sr-hint {
  display: block;
  margin-top: 4px;
  font-size: 0.75rem;
  color: #a3a3a3;
}
.sr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 42px;
  padding: 8px 20px;
  border-radius: 12px;
  border: none;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.sr-btn:focus {
  outline: 2px solid rgba(0, 95, 240, 0.3);
  outline-offset: 1px;
}
.sr-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.sr-btn-include {
  color: #fff;
  background: #16a34a;
}
.sr-btn-include:hover:not(:disabled) {
  background: #12883e;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(22, 163, 74, 0.2);
}
.sr-btn-exclude {
  color: #fff;
  background: #dc2626;
}
.sr-btn-exclude:hover:not(:disabled) {
  background: #c42020;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(220, 38, 38, 0.2);
}
.sr-loading {
  font-size: 0.82rem;
  color: #a3a3a3;
  margin-bottom: 8px;
}
.sr-err {
  font-size: 0.82rem;
  color: #dc2626;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/shared/stream-review-question-panel.component.less"],"names":[],"mappings":"AAaA;EACE,cAAA;EACA,WAAA;AAZF;AAgBA;EACE,mBAAA;EACA,oBAAA;EACA,6BAAA;AAdF;AAkBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhBF;AAmBA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,uGAAA;AAjBF;AAmBE;EACE,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yCAAA;AAjBJ;AAoBE;EACE,wCAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;AAnBJ;AAuBA;EACE,qBAAA;EACA,mBAAA;EACA,4CAAA;AArBF;AAwBA;EACE,qBAAA;EACA,mBAAA;EACA,4CAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAxBF;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AA1BF;AA6BA;EACE,mBAAA;EACA,qCAAA;AA3BF;AA8BA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;AA5BF;AA+BA;EACE,YAAA;AA7BF;AA4BA;EAII,eAAA;EACA,WAAA;AA7BJ;AAiCA;EACE,mBAAA;AA/BF;AAiCE;EACE,mBAAA;AA/BJ;AAmCA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAjCF;AAoCA;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AAlCF;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0DAAA;AAnCF;AAqCE;EACE,qBAAA;EACA,2CAAA;AAnCJ;AAuCA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,+BAAA;AArCF;AAwCA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAtCF;AAwCE;EACE,gBAAA;AAtCJ;AA0CA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAxCF;AA0CE;EACE,qBAAA;EACA,2CAAA;AAxCJ;AA4CA;EACE,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AA1CF;AA4CE;EACE,qBAAA;EACA,4CAAA;AA1CJ;AA8CA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AA5CF;AAgDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AA9CF;AAgDE;EACE,wCAAA;EACA,mBAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/CJ;AAmDA;EACE,WAAA;EACA,mBAAA;AAjDF;AAmDE;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAjDJ;AAqDA;EACE,WAAA;EACA,mBAAA;AAnDF;AAqDE;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAnDJ;AAwDA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAtDF;AAyDA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAvDF","sourcesContent":["// UDS-inspired tokens\n@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host {\n  display: block;\n  width: 100%;\n}\n\n// ── Panel ──\n.sr-panel {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid @uds-neutral-30;\n}\n\n// ── Choice tiles ──\n.sr-choice-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.sr-choice-tile {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 52px;\n  padding: 10px 16px;\n  border-radius: @uds-radius;\n  border: 2px solid @uds-neutral-30;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color @uds-ease, background @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover:not(:disabled) {\n    border-color: @uds-neutral-50;\n    background: @uds-neutral-10;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus {\n    outline: 2px solid rgba(0, 95, 240, 0.3);\n    outline-offset: 1px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.sr-tile-include.sr-tile-selected {\n  border-color: @uds-green-70;\n  background: #f0fdf4;\n  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);\n}\n\n.sr-tile-exclude.sr-tile-selected {\n  border-color: @uds-red-70;\n  background: #fef2f2;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.sr-tile-icon {\n  font-size: 1.15rem;\n  line-height: 1;\n}\n\n.sr-tile-text {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n}\n\n// ── Forms ──\n.sr-form {\n  padding: 14px;\n  border-radius: @uds-radius;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n}\n\n.sr-form-exclude {\n  background: #fef2f2;\n  border-color: rgba(220, 38, 38, 0.12);\n}\n\n.sr-form-row {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: start;\n}\n\n.sr-field-grow {\n  min-width: 0;\n\n  .sr-textarea {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n.sr-field {\n  margin-bottom: 12px;\n\n  &:last-of-type {\n    margin-bottom: 14px;\n  }\n}\n\n.sr-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n}\n\n.sr-opt {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.sr-amount-input {\n  display: flex;\n  align-items: center;\n  max-width: 11rem;\n  border: 1px solid @uds-neutral-30;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  overflow: hidden;\n  transition: border-color @uds-ease, box-shadow @uds-ease;\n\n  &:focus-within {\n    border-color: @uds-blue-70;\n    box-shadow: 0 0 0 2px rgba(0, 95, 240, 0.1);\n  }\n}\n\n.sr-dollar {\n  padding: 6px 8px 6px 10px;\n  font-weight: 700;\n  font-size: 0.88rem;\n  color: @uds-neutral-50;\n  background: @uds-neutral-20;\n  border-right: 1px solid @uds-neutral-30;\n}\n\n.sr-input {\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  padding: 6px 8px;\n\n  &:focus {\n    box-shadow: none;\n  }\n}\n\n.sr-textarea {\n  max-width: 22rem;\n  border-radius: @uds-radius-sm;\n  border-color: @uds-neutral-30;\n  font-size: 0.85rem;\n\n  &:focus {\n    border-color: @uds-blue-70;\n    box-shadow: 0 0 0 2px rgba(0, 95, 240, 0.1);\n  }\n}\n\n.sr-select {\n  max-width: 22rem;\n  border-radius: @uds-radius-sm;\n  border-color: rgba(220, 38, 38, 0.18);\n  font-size: 0.85rem;\n\n  &:focus {\n    border-color: @uds-red-70;\n    box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);\n  }\n}\n\n.sr-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: @uds-neutral-50;\n}\n\n// ── Confirm buttons ──\n.sr-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  min-height: 42px;\n  padding: 8px 20px;\n  border-radius: @uds-radius;\n  border: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:focus {\n    outline: 2px solid rgba(0, 95, 240, 0.3);\n    outline-offset: 1px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n.sr-btn-include {\n  color: #fff;\n  background: @uds-green-70;\n\n  &:hover:not(:disabled) {\n    background: darken(@uds-green-70, 6%);\n    transform: translateY(-1px);\n    box-shadow: 0 3px 10px rgba(22, 163, 74, 0.2);\n  }\n}\n\n.sr-btn-exclude {\n  color: #fff;\n  background: @uds-red-70;\n\n  &:hover:not(:disabled) {\n    background: darken(@uds-red-70, 6%);\n    transform: translateY(-1px);\n    box-shadow: 0 3px 10px rgba(220, 38, 38, 0.2);\n  }\n}\n\n// ── Status ──\n.sr-loading {\n  font-size: 0.82rem;\n  color: @uds-neutral-50;\n  margin-bottom: 8px;\n}\n\n.sr-err {\n  font-size: 0.82rem;\n  color: @uds-red-70;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
